import { AccountTenantInvite } from '../types/local/tenant'

export const isInviteAcceptable = (invite: AccountTenantInvite) => {
  return invite?.invite?.status === 'INVITE_STATUS_ACTIVE'
}
